import React from 'react'
import PropTypes from 'prop-types'
import * as Filters from 'support/filters/index'
import { Env } from '@morningtrain/helpers'
import { useAuth } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import {ca} from "date-fns/locale";

export default function EmployeeCategoryFilter (props) {
  let {
    name = 'category',
    onChange = () => {},
    defaultValue,
    allowNull = false,
    allowViewAll = true,
    forceStaticFilter = false,
    except = [],
    ...forwardProps
  } = props

  let availableScheduleCategories = Env.get('user.available_schedule_categories', [])

  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');
  const roles = [];
  hasWaiter ? roles.push('waiter'): false;
  hasKitchen ? roles.push('kitchen'): false;

  // Make sure 'except' is always an array
  except = [except].flat()

  if(except.length > 0) {
    availableScheduleCategories = availableScheduleCategories.filter(scheduleCategory => {
      return !except.includes(scheduleCategory)
    })
  }

  const auth = useAuth()

  const canViewAll = allowViewAll === true && auth.can(Permissions.SHIFTS_VIEW_ALL_AREAS)

  // Only 1 option is allowed, so just hide the filter
  if (forceStaticFilter === true || (!canViewAll && availableScheduleCategories.length === 1)
    || roles.length === 1) {
    let category = roles.length === 1 ? roles[0] : availableScheduleCategories[0]

    return (
      <Filters.StaticFilter
        name={name}
        value={category}
      />
    )
  }

  const filterProps = {
    name: name,
    enum: 'employment_type_category',
    only: availableScheduleCategories,
    onChange: onChange
  }

  if (canViewAll) {
    filterProps.only = roles;
  }

  if (typeof defaultValue === 'undefined') {
    defaultValue = filterProps.only[0]
  }

  return (
    <Filters.SwitchFilter
      {...filterProps}
      defaultValue={defaultValue}
      allowNull={allowNull}
      label={false}
      {...forwardProps}
    />
  )
}

EmployeeCategoryFilter.propTypes = {
  name: PropTypes.string
}
